import Vue from "vue";
import axios from "axios";
import Modal from "./Modal.vue";

let el = document.querySelector("#portfolio-view");
if (el)
	new Vue({
		el,
		components: {},
		data() {
			return {
				loading: true,
				failed: false,
				page: 1,
				per_page: 20,
				communities: [],
				filters: {
					community_type: false,
					asset_type: false,
					brand: false,
					location: false,
					state: false,
				},
				filtersOptions: {
					asset_type: [],
					community_type: [],
					brand: [],
					location: [],
					state: [],
				},
			};
		},
		computed: {
			limit() {
				return this.page * this.per_page;
			},
			next() {
				return this.communities.length > this.limit;
			},
		},
		methods: {
			setLimit(limit = 20) {
				// this.communities = []
				this.page = 1;
				this.per_page = limit;
				// this.getCommunities()
			},
			getFilters() {
				axios
					.get(`/wp-json/wp/v2/portfolio-filters`)
					.then((response) => {
						let filters = response.data;
						// console.log(filters)
						this.filtersOptions.brand = filters.brands;
						this.filtersOptions.asset_type = filters.asset_types;
						this.filtersOptions.community_type =
							filters.community_types;
						// this.filtersOptions.location = filters.locations

						let ordered = {};
						if (filters.locations) {
							Object.keys(filters.locations)
								.sort()
								.forEach((key) => {
									this.filtersOptions.state.push(key);
									ordered[key] = filters.locations[key];
									ordered[key].sort();
								});
							this.filtersOptions.location = ordered;
						}
					});
			},
			getCommunities() {
				this.loading = true;
				this.failed = false;
				axios
					.get(
						`/wp-json/wp/v2/community?per_page=500&orderby=title&order=asc`
					)
					.then((response) => {
						response.data.forEach((community) => {
							// if(this.communities.length == this.per_page) return
							if (
								this.filters.asset_type &&
								community.acf.asset_type !==
									this.filters.asset_type
							)
								return;
							if (
								this.filters.community_type &&
								community.acf.community_type.indexOf(
									this.filters.community_type
								) < 0
							)
								return;
							if (
								this.filters.brand &&
								community.acf.brand.post_title !==
									this.filters.brand
							)
								return;
							if (
								this.filters.location &&
								community.acf.city !== this.filters.location
							)
								return;
							if (
								this.filters.state &&
								community.acf.state !== this.filters.state
							)
								return;
							this.communities.push(community);
						});

						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
						this.failed = true;
					});
			},
			getBackground(community) {
				let url = false;
				if (community.acf.hero_image)
					url = community.acf.hero_image.sizes.large;
				if (community.acf.thumbnail_image)
					url = community.acf.thumbnail_image.sizes.large;
				if (url) return `url('${url}')`;
				return false;
			},
			hasFeature(feature, community) {
				let has = false;
				if (!community.acf.feature_buckets) return false;
				community.acf.feature_buckets.forEach((bucket) => {
					if (bucket.feature.value == feature) has = true;
				});
				return has;
			},
			filter() {
				this.communities = [];
				this.page = 1;
				this.getCommunities();
			},
			reset() {
				this.communities = [];
				this.page = 1;
				this.filters = {
					status: false,
					type: false,
					brand: false,
					location: false,
				};
				this.getCommunities();
			},
			showMore() {
				this.page++;
			},
			QueryParam(param) {
				let query = window.location.search.substring(1);
				let vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=");
					if (pair[0] == param) {
						return unescape(pair[1]);
					}
				}
				return false;
			},
		},
		mounted() {
			if (this.QueryParam("brand"))
				this.filters.brand = this.QueryParam("brand");
			this.getFilters();
			this.getCommunities();
		},
	});



// WEBPACK FOOTER //
// ./assets/js/components/_portfolio.js